/* Desktop presentation only: keep the configurator's existing total and button. */
(() => {
  const desktop = matchMedia('(min-width: 1024px)');
  for (const bar of document.querySelectorAll('[data-pc-sticky-purchase]')) {
    if (bar.dataset.desktopStickyReady) continue;
    const root = bar.closest('.a31-product');
    const price = root?.querySelector('.a31-price');
    const title = root?.querySelector('.a31-title');
    const image = root?.querySelector('.a31-hero-image');
    const thumbnail = bar.querySelector('[data-pc-sticky-image]');
    const label = bar.querySelector('[data-pc-sticky-title]');
    if (!price || !title || !thumbnail || !label) continue;
    bar.dataset.desktopStickyReady = 'true';

    function syncDetails() {
      const name = title.textContent.trim();
      if (label.textContent !== name) label.textContent = name;
      const source = image?.currentSrc || image?.src || '';
      if (source && thumbnail.getAttribute('src') !== source) thumbnail.src = source;
      thumbnail.hidden = !source;
    }
    function syncVisibility() {
      bar.dataset.desktopVisible = String(desktop.matches && price.getBoundingClientRect().bottom <= 0);
    }
    const details = new MutationObserver(syncDetails);
    const visibility = new IntersectionObserver(syncVisibility, { threshold: 0 });
    function updateViewport() {
      details.disconnect();
      visibility.disconnect();
      if (desktop.matches) {
        syncDetails();
        details.observe(title, { childList: true, characterData: true, subtree: true });
        if (image) details.observe(image, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
        visibility.observe(price);
      }
      syncVisibility();
    }
    image?.addEventListener('load', () => { if (desktop.matches) syncDetails(); });
    desktop.addEventListener('change', updateViewport);
    window.addEventListener('pageshow', updateViewport);
    updateViewport();
  }
})();
